import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';

interface RobotBatteryPercentIconProps {
  batteryPercentageNumber: number;
  isCharging?: boolean;
  // A size of 24px or smaller switches to the small/coloured icon set (batterySmallXX), sized
  // accordingly; omitting it or passing a larger size keeps the original larger icon set
  // (batteryXXPercent) at its native size.
  size?: number;
}

export const RobotBatteryPercentIcon = ({
  batteryPercentageNumber,
  isCharging,
  size,
}: RobotBatteryPercentIconProps): JSX.Element => {
  if (size && size <= 24) {
    if (isCharging) return <SvgIcon name="batterySmallLoading" size={size} />;

    if (batteryPercentageNumber >= 86) return <SvgIcon name="batterySmall100" size={size} />;

    if (batteryPercentageNumber >= 66) return <SvgIcon name="batterySmall75" size={size} />;

    if (batteryPercentageNumber >= 36) return <SvgIcon name="batterySmall50" size={size} />;

    if (batteryPercentageNumber >= 16) return <SvgIcon name="batterySmall25" size={size} />;

    return <SvgIcon name="batterySmallEmpty" size={size} />;
  }

  if (batteryPercentageNumber >= 86) return <SvgIcon name="battery100Percent" />;

  if (batteryPercentageNumber >= 66) return <SvgIcon name="battery75Percent" />;

  if (batteryPercentageNumber >= 36) return <SvgIcon name="battery50Percent" />;

  if (batteryPercentageNumber >= 16) return <SvgIcon name="battery25Percent" />;

  return <SvgIcon name="battery00Percent" />;
};
